<template>
    <div class="simple-toggle" @click="toggle">
      <div class="toggle-background" :class="{ active: value }">
        <div class="toggle-indicator" :class="{ active: value }"></div>
      </div>
      <span class="toggle-label">{{ label }}</span>
    </div>
  </template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggle () {
      this.$emit('input', !this.value)
    }
  }
}
</script>

  <style scoped>
  .simple-toggle {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .toggle-background {
    width: 32px;
    height: 18px;
    background-color: #c2c2c2;
    border-radius: 9999px;
    position: relative;
    transition: background-color 0.3s ease;
  }

  .toggle-background.active {
    background-color: #4bb543;
  }

  .toggle-indicator {
    width: 14px;
    height: 14px;
    background-color: #ffffff;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: transform 0.3s ease;
  }

  .toggle-indicator.active {
    transform: translateX(14px);
  }

  .toggle-label {
    margin-left: 10px;
    font-size: 14px;
    color: #434a54;
  }
  </style>



// WEBPACK FOOTER //
// src/components/UI/toogleSwitch/SimpleToggle.vue